import React, { useState } from "react";
import { Spinner, textTruncate } from "@px/px_design_system";
import PropTypes from "prop-types";
import PaginatedDownloadCsv from "../../Utilities/PaginatedDownloadCsv";
import { Table } from "../../Utilities/Table";
import { convertJSONToCSVInWorker, getUTCDateTime } from "../../../../../utils";
import ToolTipMessages from "../../Utilities/ToolTip/TooltipMessages";
import geosegmentModel from "../../../models/Geosegment";
import DownloadDataDict from "../../Utilities/DownloadDataDict";
import "./style.css";

const MeasurementDetails = ({
  displayError,
  errorMessage,
  fetchGeosegments,
  history,
  isLoaded,
  loading,
  totalGeosegments,
  totalSize,
  isSuperUser,
  tabName,
  orgData,
}) => {
  const [finalGeosegments, setFinalGeosegments] = useState("");

  const geosegmentColumn = [
    {
      accessorKey: "name",
      header: "Geo Segment Name",
    },
    {
      accessorKey: "adunit_id",
      header: "Ad Unit Id",
    },
    {
      accessorKey: "provider_name",
      header: "Provider",
    },
    {
      accessorKey: "segment_name",
      header: "Segment",
    },
    {
      accessorKey: "geo_code",
      header: "Geo Code",
    },
    {
      accessorKey: "geo_name",
      header: "Geo Name",
    },
    {
      accessorKey: "geo_type",
      header: "Geo Type",
    },
    {
      accessorKey: "lastmod",
      header: "Last Modified",
      accessorFn: (row) => (row?.lastmod ? getUTCDateTime(row?.lastmod) : "-"),
    },
    {
      accessorKey: "id",
      header: "Id",
      accessorFn: (row) => textTruncate(row?.id),
    },
  ];

  let measurementObj = {
    columns: geosegmentColumn,
    csvFileName: "Geosegments",
    fetchApiData: fetchGeosegments,
    totalCount: totalGeosegments,
    totalDataSize: totalSize,
  };

  const csvDataToDownload = async (json) => {
    const csvBlobUrl = await convertJSONToCSVInWorker(json, geosegmentModel);
    setFinalGeosegments(csvBlobUrl);
  };

  const spinnerProps = {
    className: "spinner-icon",
    color: "primary",
    loadingtext: "Loading",
  };

  return (
    <>
      <div
        className={`geosegment--measurement-list  ${
          displayError ? "no--data--found" : ""
        } ${isLoaded ? "wrapper" : "wrapper--no-border"}`}
      >
        {(!isLoaded || loading) && <Spinner {...spinnerProps} />}
        {isLoaded && !loading && (
          <div
            className={`geosegment--measurement-container measurement-container-${tabName}  ${
              isSuperUser ? "super--user" : "non--super--user"
            }`}
          >
            <h2 className="geosegment__headline geosegment__headline--copy sub__headline--count">
              {tabName === "geosegments" ? (
                <>Geo Segments</>
              ) : (
                // currently, Geosegments is the only available tab; short term plans to add addtional
                <>Geo Segments</>
              )}
            </h2>

            <Table
              history={history}
              table_columns={measurementObj.columns}
              name="geosegments_enriched"
              orgId={orgData.id}
              renderTopToolbarCustomActions={() => (
                <div className="geosegment-buttons">
                  <DownloadDataDict />
                  <PaginatedDownloadCsv
                    disableDownloadCsv={totalGeosegments === 0}
                    disableDownloadText={
                      totalGeosegments === 0
                        ? ToolTipMessages.DOWNLOAD_CSV.title
                        : ""
                    }
                    componentName="Measurement"
                    fetchData={measurementObj.fetchApiData}
                    csvDataToDownload={csvDataToDownload}
                    tabPillCount={measurementObj.totalCount}
                    finalData={finalGeosegments}
                    removeColumns={measurementObj.removeColumns}
                    renameHeaders={{ name: "geosegment_name" }}
                    filename={measurementObj.csvFileName}
                    tabName={tabName}
                    key={tabName}
                    dataSize={measurementObj.totalDataSize}
                  />
                </div>
              )}
            />
          </div>
        )}
      </div>
    </>
  );
};

MeasurementDetails.propTypes = {
  measurementData: PropTypes.arrayOf(PropTypes.object),
  displayError: PropTypes.bool,
  errorMessage: PropTypes.shape(),
  fetchGeosegments: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  isLoaded: PropTypes.bool,
  isSuperUser: PropTypes.bool,
  loading: PropTypes.bool,
  orgName: PropTypes.string,
  orgData: PropTypes.shape(),
  setLoader: PropTypes.func,
  totalGeosegments: PropTypes.number,
  totalSize: PropTypes.number,
  triggerLoadData: PropTypes.func,
  tabItems: PropTypes.arrayOf(PropTypes.object),
  tabName: PropTypes.string,
  userPermission: PropTypes.bool,
  userData: PropTypes.shape(),
};

export default MeasurementDetails;
